/* eslint-disable react/no-danger */
import React, {useEffect} from 'react';
import {useInjectSaga} from 'utils/injectSaga';
import postSaga from 'sagas/postSaga';
import companySaga from 'sagas/companySaga';
import {useDispatch, useSelector} from 'react-redux';
import {fetchAbout, getCompanyById} from 'actions/companyActions';
import Header from 'components/Header';
import Sidebar from 'components/Sidebar';
import CompanyInfo from 'components/CompanyInfo/updated';
import 'styles/blog-post-edit.scss';

const PreviewPost = ({match}) => {
  useInjectSaga({key: 'post', saga: postSaga});
  useInjectSaga({key: 'company', saga: companySaga});
  const {companyId} = match.params;

  const dispatch = useDispatch();
  const companySelector = useSelector((state) => state.company);

  useEffect(() => {
    dispatch(getCompanyById(companyId));
    dispatch(fetchAbout(companyId));
  }, []);

  return (
    <>
      <Header />
      <div className="wrapper">
        <Sidebar />
        <div className="content_wrapper">
          <CompanyInfo
            company={companySelector.company}
            className="text-black"
            containerClass="low-margin"
          />
          {companySelector.about && companySelector.about._id && (
            <div
              className="pt-4 bg-white"
              dangerouslySetInnerHTML={{
                __html: companySelector.about.description,
              }}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default PreviewPost;
